export default ({keys, server}) => `package com.example.app

import com.stripe.android.PaymentConfiguration

class MyApp : Application() {
    override fun onCreate() {
        super.onCreate()
        PaymentConfiguration.init(
            applicationContext,
            "${keys.publishable || 'pk_1235'}"
        )
    }
}
`;
